import { useNavigate } from "react-router-dom";
import HDLogo from "../../assets/logo-chatbot-white.png";
import HDFavicon from "../../assets/favicon_white.svg";
import "./Logo.scss";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useLayout } from "../../contexts/LayoutContext";

// export default function Logo({ collapsed }) {
export default function Logo() {
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const { collapsed, isMobile } = useLayout();

  const perms = currentUser?.permissions || [];
  const isSper = perms.includes("superadmin");
  const isOpen = perms.includes("groupadmin");

  const LogoLink = isSper ? "/users" : "/my-sessions";

  // em mobile, ignoramos o collapsed (mostra sempre o logo favicon)
  const effectiveCollapsed = isMobile ? true : collapsed;

  return (
    <div className="logo" onClick={() => navigate(LogoLink)}>
      {effectiveCollapsed ? (
        <img src={HDFavicon} alt="HoteisDigitais Logo" />
      ) : (
        <div className="logo-brand">
          <img src={HDLogo} alt="HoteisDigitais Chatbot Logo" />
        </div>
      )}
    </div>
  );
}
